import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bootstrapQueryReference", "tenantContextsQueryReference", "children", "cloudId"],
  _excluded2 = ["children", "queryReference"];
import _hubBootstrapWrapperQuery from "./__generated__/hubBootstrapWrapperQuery.graphql";
import _hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference from "./__generated__/hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference.graphql";
import _hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference from "./__generated__/hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference.graphql";
/* eslint-disable @atlassian/relay/unused-fields */
import React from 'react';
import { graphql, useFragment, usePreloadedQuery } from 'react-relay';
import { DEFAULT_BRANDING_COLOR } from '../../constants';
import { HubContext } from '../../utils';
export var HubBootstrap = function HubBootstrap(_ref) {
  var _tenantData$tenantCon, _tenantData$tenantCon2, _data$helpCenterById, _branding$colors$prim, _branding$colors;
  var bootstrapQueryReference = _ref.bootstrapQueryReference,
    tenantContextsQueryReference = _ref.tenantContextsQueryReference,
    children = _ref.children,
    cloudId = _ref.cloudId,
    props = _objectWithoutProperties(_ref, _excluded);
  var data = useFragment(_hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference, bootstrapQueryReference);
  var tenantData = useFragment(_hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference, tenantContextsQueryReference);
  var cloudUrl = (_tenantData$tenantCon = (_tenantData$tenantCon2 = tenantData.tenantContexts) === null || _tenantData$tenantCon2 === void 0 || (_tenantData$tenantCon2 = _tenantData$tenantCon2[0]) === null || _tenantData$tenantCon2 === void 0 ? void 0 : _tenantData$tenantCon2.cloudUrl) !== null && _tenantData$tenantCon !== void 0 ? _tenantData$tenantCon : window.location.origin;
  if (!data.helpCenterById) {
    throw new Error('Help center not found');
  }
  var branding = (_data$helpCenterById = data.helpCenterById) === null || _data$helpCenterById === void 0 ? void 0 : _data$helpCenterById.helpCenterBranding;
  var logo = branding === null || branding === void 0 ? void 0 : branding.logo;
  var primaryColor = (_branding$colors$prim = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) !== null && _branding$colors$prim !== void 0 ? _branding$colors$prim : undefined;
  var fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
  var url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
  return /*#__PURE__*/React.createElement(HubContext.Provider, {
    value: {
      pageMediaConfig: data.pageMediaConfig,
      hubMediaConfig: data.hubMediaConfig,
      branding: {
        logo: {
          fileId: fileId,
          url: url
        },
        colors: {
          primary: primaryColor || DEFAULT_BRANDING_COLOR
        }
      },
      layout: props.layout,
      user: props.user,
      env: props.env,
      actions: props.actions,
      renderRightNavActions: props.renderRightNavActions,
      cloudId: cloudId,
      cloudUrl: cloudUrl
    }
  }, children);
};
export var HubBootstrapWrapper = function HubBootstrapWrapper(_ref2) {
  var children = _ref2.children,
    queryReference = _ref2.queryReference,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var data = usePreloadedQuery(_hubBootstrapWrapperQuery, queryReference);
  if (!data.helpCenter) {
    return null;
  }
  return /*#__PURE__*/React.createElement(HubBootstrap, _extends({
    bootstrapQueryReference: data.helpCenter,
    tenantContextsQueryReference: data
  }, props), children);
};